import { FormVersionNS, FormVersionSchema } from "@smart/bridge-types-basic";
import { buildTableDef } from "@smart/itops-constructs-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const formVersionGuard = wrapSchema(FormVersionSchema);

export const FormVersionDef = buildTableDef(
  {
    namespace: FormVersionNS,
    guard: formVersionGuard,
    keyFields: ["uri"],
    keySchema: { uri: "string" },
  } as const,
  {
    byForm: {
      indexName: "byForm",
      keyFields: ["formUri", "createdAt"],
      keySchema: { formUri: "string", createdAt: "string" },
    },
  } as const,
);
